<template>
    <div class="panel-card">
        <div class="panel-header">
            <div class="panel-title">外部网站链接</div>
        </div>
        <div class="panel-body">
            <div class="link-grid">
                <a v-for="item in list" :key="item.id" class="link-cell" target="_blank" :href="getLink(item)">
                    <div class="link-icon">
                        <img :src="item.imagePath" alt="系统图标" />
                    </div>
                    <div class="link-name">{{ item.title }}</div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OuterLinks',
    data() {
        return {
            list: [
                // {
                //     imagePath: require('../assets/cosys.png'),
                //     title: "协同设计(新)",
                //     path: "https://portal.njszy.com/cosys/#/dashboard",
                // },
                {
                    imagePath: require('../assets/22.png'),
                    title: "协同设计(旧)",
                    path: "http://218.94.135.30:8025/portal/",
                },
                {
                    // icon: require('../assets/11.jpeg'),
                    imagePath: require('../assets/33.png'),
                    title: "三纲出图",
                    path: "http://10.23.23.118",
                },
                {
                    imagePath: require('../assets/bk-water.jpeg'),
                    title: "集团门户",
                    path: 'https://portal.bewg.net.cn',
                },
                // {
                //     imagePath: require('../assets/email.png'),
                //     title: "企业邮箱",
                //     path: 'https://qiye.aliyun.com/alimail/',
                // },

                {
                    imagePath: require('../assets/partyManage.png'),
                    title: "智慧党建",
                    path: 'https://portal.njszy.com/party',
                },
                {
                    imagePath: require('../assets/bidinfo.svg'),
                    title: "招标信息",
                    path: 'https://bidinfo.njszy.com/',
                    sso: true,
                },
                {
                    imagePath: require('../assets/oa.png'),
                    title: "集团OA",
                    path: 'https://oa.bewg.net.cn/seeyon/main.do?method=main',
                },
                // {
                //     imagePath: require('../assets/bill.png'),
                //     title: "网上报销",
                //     path: 'https://bewgfinance.bewg.net.cn/ierp/?formId=pc_main_console&code=87fcSe&state=/ierp/',
                // }
            ],
        };
    },

    methods: {
        // 拼接跳转地址；标记 sso 的站点与本系统同账号，携带当前登录 token 免登陆
        getLink(item) {
            if (!item.sso) {
                return item.path;
            }
            const token = window.localStorage.getItem('token') || '';
            return item.path + '?sso=' + encodeURIComponent(token);
        },
    },

};
</script>

<style scoped>
.panel-card {
    background: #fff;
    border: 1px solid #eef0f3;
    border-radius: 12px;
}
.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #f0f0f0;
}
.panel-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    padding-left: 12px;
    /* border-left: 4px solid #2563eb; 删掉原来的border-left */
    position: relative;
}
.panel-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 20px; /* 控制竖线高度，按需修改 */
    background-color: #2563eb;
}

.panel-body {
    padding: 10px 18px;
}
.link-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 12px;
}
.link-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
}
.link-icon {
    width: 42px;
    height: 42px;
    background: #f0f4ff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 6px;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
.link-name {
    font-size: 12px;
    color: #444;
    white-space: nowrap;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
